import React, { useState } from 'react';
import { Link } from 'react-router';
import Isvg from 'react-inlinesvg';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Heading } from 'components/Heading/Heading';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { Section } from 'components/Section/Section';
import { DESIGN_SYSTEM_ICONS } from 'constants/icons';
import { getSearchURLFromFilter } from '../Search.helpers';
import css from '../Search.scss';

export const SearchRelatedLinks = ({ titleMessage, titleMessageValues, filters }) => {
  const [hasVisibleLinks, setLinksVisible] = useState(false);

  const handleToggleLinksVisible = () => {
    setLinksVisible(!hasVisibleLinks);
  };

  const promptIcon = hasVisibleLinks ? DESIGN_SYSTEM_ICONS.arrowUpSmall : DESIGN_SYSTEM_ICONS.arrowDownSmall;

  return (
    <Section className={css.Search__relatedLinks}>
      <div className={css.Search__relatedLinks__header} onClick={handleToggleLinksVisible}>
        <Heading className="zeta">
          <LocalizableMessage message={titleMessage} values={titleMessageValues} />
        </Heading>
        <Isvg src={promptIcon} />
      </div>
      <ul
        className={cx({
          hidden: !hasVisibleLinks,
        })}>
        {filters.map(filter => (
          <li key={filter.hash}>
            <Link to={getSearchURLFromFilter(filter)}>{filter.content.header1}</Link>
          </li>
        ))}
      </ul>
    </Section>
  );
};

export const filterShape = PropTypes.shape({
  hash: PropTypes.string.isRequired,
  content: PropTypes.shape({
    header1: PropTypes.string.isRequired,
    activity_descriptor: PropTypes.string.isRequired,
    location_descriptor: PropTypes.string.isRequired,
  }).isRequired,
});

SearchRelatedLinks.propTypes = {
  titleMessage: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
  }).isRequired,
  titleMessageValues: PropTypes.object,
  filters: PropTypes.arrayOf(filterShape).isRequired,
};
